export default class CustomReplacementCostInput {
  constructor(obj) {
    this.id = obj.id;
    this.is_condo = obj.is_condo;
    this.zip_code = obj.zip_code;
    this.building_shape_id = obj.building_shape_id;
    this.total_area_sq_ft = obj.total_area_sq_ft;
    this.has_attached_garage = obj.has_attached_garage;
    this.parking_spaces_count = obj.parking_spaces_count;
    this.fireplaces = obj.fireplaces;
    this.stories = obj.stories;
    this.has_unfinished_basement = obj.has_unfinished_basement;
    this.has_finished_basement = obj.has_finished_basement;
    this.has_central_heating_cooling = obj.has_central_heating_cooling;
    this.has_central_heating = obj.has_central_heating;
    this.has_floor_or_wall_furnace = obj.has_floor_or_wall_furnace;
    this.balcony_sqft = obj.balcony_sqft;
    this.wood_deck_sqft = obj.wood_deck_sqft;
    this.covered_porch_sqft = obj.covered_porch_sqft;
    this.email = obj.email;
    this.first_name = obj.first_name;
    this.last_name = obj.last_name;
    this.created_at = obj.created_at;
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.formatted_street_address = obj.formatted_street_address;
    this.city = obj.city;
    this.state = obj.state;
  }
}
